export default "__VITE_ASSET__C7nbv9bF__"